import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import s from './POSSolutionListStyles.scss';
import { Box, Text, Button, Image, TextButton } from '@wix/design-system';
export let POSSolutionListType = /*#__PURE__*/function (POSSolutionListType) {
  POSSolutionListType["RETAIL_POS"] = "RETAIL_POS";
  POSSolutionListType["MOBILE_POS"] = "MOBILE_POS";
  POSSolutionListType["TAP_2_PAY"] = "TAP_2_PAY";
  POSSolutionListType["DASHBOARD"] = "DASHBOARD";
  return POSSolutionListType;
}({});
export let POS_SideEffectEvents = /*#__PURE__*/function (POS_SideEffectEvents) {
  POS_SideEffectEvents["posBookButtonClick"] = "pos-book-a-call-button-click";
  POS_SideEffectEvents["posLearnMoreButtonClick"] = "pos-learn-more-button-click";
  return POS_SideEffectEvents;
}({});
const solutionMap = {
  [POSSolutionListType.RETAIL_POS]: {
    imageUrl: 'https://static.wixstatic.com/media/4d4b03_42e7eadd3fca4333afa1764adc03c9ce~mv2.png/v1/fill/w_420,h_280,al_c,q_85,usm_0.66_1.00_0.01/4d4b03_42e7eadd3fca4333afa1764adc03c9ce~mv2.png',
    name: 'Wix POS Register',
    description: 'Wix POS Register hardware to suit your business needs and get a powerful point of sale that looks great in your physical store.',
    link: 'https://www.wix.com/pos/hardware/product-page/the-complete-retail-pos-package-epson-printer?utm_campaign=vir_POS_BO_posPage-AiAssistant_learnMoreRetail&referral=aiAssistant-allOptions',
    price: 'From $1,395.00'
  },
  [POSSolutionListType.MOBILE_POS]: {
    imageUrl: 'https://static.wixstatic.com/media/4d4b03_f0ebd1e15ca24e81b626c1f30f6503d8~mv2.png/v1/fill/w_420,h_280,al_c,q_85,usm_0.66_1.00_0.01/4d4b03_f0ebd1e15ca24e81b626c1f30f6503d8~mv2.png',
    name: 'Mobile POS',
    description: 'Take payments anywhere with portable reader. Easy start with low investment & take payments right away.',
    link: 'https://www.wix.com/pos/hardware/product-page/card-reader-dock-bundle?utm_campaign=vir_POS_BO_posPage-AiAssistant_learnMoreMobile&referral=aiAssistant-allOptions',
    price: 'From $59.00'
  },
  [POSSolutionListType.TAP_2_PAY]: {
    imageUrl: 'https://static.wixstatic.com/media/4d4b03_76c8870f342449cbae71536f35d3de81~mv2.png/v1/fill/w_420,h_280,al_c,q_85,usm_0.66_1.00_0.01/4d4b03_76c8870f342449cbae71536f35d3de81~mv2.png',
    name: 'Tap to pay (Wix app)',
    description: 'Take payments anywhere with your phone. Easy start with low investment & take payments right away',
    link: 'https://support.wix.com/en/article/wix-mobile-pos-setting-up-tap-to-pay?utm_campaign=vir_POS_BO_posPage-AiAssistant_learnMoreMobile&referral=aiAssistant-allOptions',
    price: '$0.00'
  },
  [POSSolutionListType.DASHBOARD]: {
    imageUrl: 'https://static.wixstatic.com/media/4d4b03_538ead0b674542499fc07b8c710f51e0~mv2.png/v1/fill/w_420,h_280,al_c,q_85,usm_0.66_1.00_0.01/4d4b03_538ead0b674542499fc07b8c710f51e0~mv2.png',
    name: 'Dashboard Reader',
    description: 'Manage your in person and online business by connecting this card reader to the Wix Dashboard on your computer.',
    link: 'https://www.wix.com/pos/hardware/product-page/wisepos-desktop-card-reader?utm_campaign=vir_POS_BO_posPage-AiAssistant_learnMoreDesktop&referral=aiAssistant-allOptions',
    price: '$295.00'
  }
};
export const POSSolutionList = props => {
  const onExpertButtonClick = React.useCallback(() => {
    props.context.onWidgetAction(POS_SOLUTION_LIST, {
      action: 'book-a-call-button-click'
    });
    props.context.emitSideEffect(POS_SideEffectEvents.posBookButtonClick, {
      origin: 'ai assistant',
      pageState: 'book a call'
    });
  }, [props]);
  React.useEffect(() => {
    props.context.onWidgetAction(POS_SOLUTION_LIST, {
      action: 'appeared',
      value: JSON.stringify(props.data.solutionList)
    });
  }, []);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium"
  }, "Here are POS solutions that can suit your business needs:"), props.data.solutionList.map(posType => {
    const solutionDescription = solutionMap[posType];
    return /*#__PURE__*/React.createElement(POSSolutionItem, _extends({}, solutionDescription, {
      context: props.context,
      key: solutionDescription.name
    }));
  }), /*#__PURE__*/React.createElement(Box, {
    paddingTop: "12px"
  }, /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    onClick: onExpertButtonClick,
    size: "tiny",
    target: "_blank",
    href: "https://www.wix.com/pos/book-a-call-wix-pos/booking-calendar/book-a-call-with-a-pos-expert?utm_campaign=vir_POS_BO_posPage-AiAssistant_bookCall&referral=aiAssistant-allOptions"
  }, "Not sure? Contact POS expert")));
};
const POSSolutionItem = /*#__PURE__*/React.memo(solutionDescription => {
  const onLearnMoreButtonClick = React.useCallback(() => {
    solutionDescription.context.onWidgetAction(POS_SOLUTION_LIST, {
      action: 'learn-more-button-click',
      value: solutionDescription.name
    });
    solutionDescription.context.emitSideEffect(POS_SideEffectEvents.posLearnMoreButtonClick, {
      origin: 'ai assistant',
      subOrigin: 'all options',
      cta: solutionDescription.name
    });
  }, [solutionDescription]);
  return /*#__PURE__*/React.createElement(Box, {
    gap: "12px",
    border: "1px solid red",
    borderRadius: "12px",
    borderColor: "B40",
    padding: "SP3"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "8px"
  }, /*#__PURE__*/React.createElement(Image, {
    height: "140px",
    src: solutionDescription.imageUrl
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "space-between",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, solutionDescription.name), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    className: s.textColor
  }, solutionDescription.price)), /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    as: "a",
    priority: "secondary",
    target: "_blank",
    href: solutionDescription.link,
    onClick: onLearnMoreButtonClick
  }, "Learn More")), /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, solutionDescription.description)));
});
export const POS_SOLUTION_LIST = 'POS_SOLUTION_LIST';
//# sourceMappingURL=POSSolutionList.js.map